module.exports = __webpack_public_path__ + "img/UN_Women_Spurning03.7fd0ae9e.gif";